import React, { useState } from 'react';
import { Button, Modal, Form, Input, InputNumber, Select, message } from 'antd';
import * as Setting from '../utils/AuthUtils';
import { api } from '../AppConfig';
import { composeSelectOptions } from '../utils/ComponentUtils';

function UpdateTournament(props) {
    const [form] = Form.useForm();
    const [isActive,setIsActive] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();

    function toggleModal() {
        if (isActive) {
            setIsActive(false);
        } else {
            setIsActive(true);
        }
    }

    function handleCancel() {
        setIsActive(false);
        form.resetFields();
    }

    function onFinish(values) {
        form.validateFields({ validateOnly: true })
        .then(async () => {
            const tournament = props.tournament;
            tournament.decklist = values.decklist;
            tournament.multiplier.id = values.multiplier;
            tournament.playerAttendancy = values.participants;
            tournament.turns = values.turns;
            tournament.isDone = true;
            tournament.name = values.name;

            if (values.turns === 0 || values.participants === 0 || values.multiplier === 0) {
                throw new Error('Form values not valid!');
            }
            const response = await fetch(api.tournaments().update().href, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + Setting.getToken(),
                // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(tournament) // body data type must match "Content-Type" header
            })
            .then((data) => data.json())

            if (response.errorMsg === "") {
                window.location.reload(false);
            } else {
                messageApi.error("You do not have the permission to edit this tournament status! Check the inserted infos.");
            }
        })
        .catch((errorInfo) => {
            // console.warn('errorInfo:', errorInfo);
            messageApi.error("Please compile all required fields of the form!");
        })
    }

    return(
            <div>
                {contextHolder}
                <Modal title="Close Tournament" open={isActive} trigger="click" onOk={form.submit} onCancel={handleCancel} maskClosable={false} cancelText="Cancel" okText="Update">
                    <Form form={form} onFinish={onFinish} labelCol={{ span: 8, }} wrapperCol={{ span: 16, }} initialValues={{ "name": props.tournament.name, "type": (props.tournament && props.tournament.type ? props.tournament.type.desc : ''), "multiplier":  (props.tournament && props.tournament.multiplier ? props.tournament.multiplier.id : 0), "participants": props.tournament.playerAttendancy, "turns": props.tournament.turns }}>
                    <Form.Item label="Tournament" name="name" >
                        <Input disabled={!(props.rights ? props.rights.isAdmin : false)} placeholder="Tournament Name" />
                    </Form.Item>
                    <Form.Item label="Type" name="type" >
                        <Input disabled={true} placeholder="Tournament Type" />
                    </Form.Item>
                    <Form.Item label="Split" name="multiplier" rules={[{ required: true, message: 'Please select a value!' }]}>
                        <Select placeholder="Select option">
                            {composeSelectOptions((props.multipliers && props.multipliers.data ? props.multipliers.data.payLoad : []),{key: 'id', value: 'id', desc: 'desc'})}
                        </Select>
                    </Form.Item>
                    <Form.Item label="Participants" name="participants" rules={[{ required: true, message: 'Please insert a value!' },({ getFieldValue }) => ({
                        validator(_, value) {
                            if (!value || value > 0) {
                            return Promise.resolve();
                        }
                        return Promise.reject(new Error('Please insert a value greater than 0!'));
                        },
                    })]}>
                        <InputNumber min={8} max={800} placeholder="no. of participants" />
                    </Form.Item>
                    <Form.Item label="Rounds" name="turns" rules={[{ required: true, message: 'Please insert a value!' }]}>
                        <InputNumber min={3} max={15} placeholder="no. of swiss rounds" />
                    </Form.Item>
                </Form>
                </Modal>
                <Button style={{ marginTop: 16 }} type="primary" onClick={toggleModal}>
                    EDIT TOURNAMENT
                </Button>
            </div>
    )
}

export default UpdateTournament;